import { SWITCH_FUNCTION_ENUM } from './parser';

export const INCORRECT_SWITCH_ARGUMENTS_ERROR = `Arguments of ${SWITCH_FUNCTION_ENUM.SWITCH} function should be ${SWITCH_FUNCTION_ENUM.CASE}`;

export const EACH_CASE_SAME_RETURN_TYPE_ERROR = `Each ${SWITCH_FUNCTION_ENUM.CASE} (2 arg) in ${SWITCH_FUNCTION_ENUM.SWITCH} function should have the same type`;
